import React from 'react';
import Icon from 'components/AppIcon';

export default function ProfileNameField({ value, onChange, error, disabled }) {
  return (
    <div>
      <label htmlFor="name" className="block text-sm font-medium text-foreground mb-1">
        Full Name
        <span className="text-destructive ml-1">*</span>
      </label>
      <input
        id="name"
        name="name"
        type="text"
        placeholder="e.g. Jane Doe"
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        maxLength={100}
        className={`w-full px-3 py-2 rounded-md border text-sm bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-colors disabled:opacity-60 ${
          error ? 'border-destructive focus:ring-destructive' : 'border-input'
        }`}
      />
      {error && (
        <p className="mt-1 text-xs text-destructive flex items-center gap-1">
          <Icon name="AlertCircle" size={12} />
          {error}
        </p>
      )}
    </div>
  );
}
